import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#17E860",
      "fill-rule": "evenodd",
      d: "M4.667 9.334a2 2 0 0 0 2 2H12a2 2 0 0 0 2-2V4.001a2 2 0 0 0-2-2H6.667a2 2 0 0 0-2 2zm2 .667A.667.667 0 0 1 6 9.334V4.001c0-.369.299-.667.667-.667H12c.368 0 .667.298.667.667v5.333a.667.667 0 0 1-.667.667z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#17E860",
      d: "M2 11.476A2.524 2.524 0 0 0 4.524 14h4.81a.667.667 0 0 0 0-1.333h-4.81a1.19 1.19 0 0 1-1.19-1.19v-4.81a.667.667 0 1 0-1.334 0z"
    }, null, -1)
  ])))
}
export default { render: render }